import styled, { css } from 'styled-components'
import { Drawer, Layout as AntLayout } from 'antd'
import { borderRadius, padding, color, margin, screen, rgbaColor } from 'theme/mixins'
import Container from 'components/Container'

const LOGO_HEIGHT = 52

const Menu = css`
	.ant-menu {
		padding: 0 ${padding('sm')};

		.ant-menu-item-divider {
			border-color: ${color(['gray', '300'])};
			margin: ${margin('md')} 0;
		}

		.ant-menu-item {
			border-radius: ${borderRadius('sm')};
			display: flex;
			align-items: center;
			height: auto;
			line-height: initial;
			margin-top: 0;
			padding: ${({ theme }) => `${theme.paddings.sm - 3}px`};

			.ant-menu-item-icon {
				min-width: 22px;
				font-size: 22px;
				display: flex;
				line-height: initial;
			}
		}
	}
`

const Layout = styled(AntLayout)<{ $isIframe: boolean }>`
	padding: 0;

	.ant-layout-sider {
		position: sticky;
		top: 0;
		left: 0;
		z-index: 2;

		${({ $isIframe }) =>
			!$isIframe &&
			css`
				min-height: calc(100vh - ${padding('sm')});
				height: 100vh;
			`}
	}

	.ant-layout-sider-trigger {
		top: 0;
		right: 0;
		width: ${LOGO_HEIGHT}px !important;
		height: ${LOGO_HEIGHT}px;
		line-height: ${LOGO_HEIGHT}px;
		position: absolute;
		background: transparent;
		font-size: 22px;
	}

	.ant-layout-sider-children {
		display: flex;
		flex-direction: column;
		background: ${color(['primary', '100'])};
		box-shadow: 0 0px 8px 0 ${rgbaColor('black', 0.2)};
	}

	${Menu};

	.ant-layout-sider-collapsed {
		.ant-layout-sider-trigger {
			width: 100% !important;
		}
	}

	> .ant-layout-content {
		padding-bottom: 80px;
		display: flex;
		flex-direction: column;

		${screen.gte.md`
			padding-bottom: ${padding('sm')};
		`}
	}
`

const SiderHeader = styled(Container)<{ $collapsed: boolean }>`
	height: 80px;
	justify-content: center;

	a {
		img {
			/* Fix because of logo size font difference vs title */
			height: 49px;
			margin-left: -12px;
		}
	}

	${({ $collapsed }) =>
		!$collapsed &&
		css`
			justify-content: flex-start;

			.ant-btn-icon-only {
				min-width: 32px;
				height: 32px;
				padding: ${padding('xxs')} 0;
			}
		`}
`

const ContentLayout = styled(AntLayout)`
	padding: 0 ${padding('md')};
	flex: 1;

	.ant-layout-header {
		padding: 0;
		height: 80px;
		position: sticky;
		top: 0;
		z-index: 1;
		display: flex;
		align-items: center;

		.ant-typography {
			margin: 0;
		}
	}

	> .ant-layout-content {
		display: flex;
		flex-direction: column;
		overflow: auto;
	}
`

const ClientHeader = styled(AntLayout.Header)`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	background: ${color(['info', '000'])};
	border-bottom: 1px solid ${color(['info', '400'])};
`

const Referral = styled(Container)`
	position: absolute;
	top: 50px;
	left: 50%;
	transform: translateX(calc(-50% + 26px)); /* image size */
	width: 100%;
	justify-content: center;
	display: flex;
	align-items: center;

	img {
		width: 26px;
		height: 26px;
	}
`

const MobileMenu = styled(Drawer)`
	.ant-drawer-header {
		border: none;
		padding: ${padding('sm')};
	}

	${Menu}

	.ant-drawer-body {
		padding: 0;
		display: flex;
		flex-direction: column;
	}

	.ant-drawer-close {
		display: none;
	}
`

export default { Layout, SiderHeader, ClientHeader, ContentLayout, Referral, MobileMenu }
